import { useEffect, useState } from "react";
import { GetLatestArticles } from "../../../Api/Article";
import ArticleDTO from "../../../Models/DTOs/ArticleDTO";

function useFetchLatestArticles(take: number, skip: number, shouldAppendData: boolean) {
    const [articles, setArticles] = useState<ArticleDTO[]>([]);
    const [articlesLoading, setArticlesLoading] = useState<boolean>(false);
    const [articlesError, setArticlesError] = useState<string>("");

    useEffect(() => {
        const abortController = new AbortController();
        setArticlesLoading(true);

        (async () => {
            try {
                const data = await GetLatestArticles(take, skip, abortController);
                if (!abortController.signal.aborted && data?.items) {
                    setArticles((prev) =>
                        shouldAppendData ? [...prev, ...data.items] : data.items
                    );
                }
            } catch (err: any) {
                if (!abortController.signal.aborted) {
                    console.error(err);
                    setArticlesError("Failed to fetch latest articles.");
                }
            } finally {
                if (!abortController.signal.aborted) {
                    setArticlesLoading(false);
                }
            }
        })();

        return () => abortController.abort();
    }, [take, skip, shouldAppendData]);

    return { articles, articlesLoading, articlesError };
}

export default useFetchLatestArticles;
